import { render, staticRenderFns } from "./offerList.vue?vue&type=template&id=bb4bc36c&scoped=true&"
import script from "./offerList.vue?vue&type=script&lang=js&"
export * from "./offerList.vue?vue&type=script&lang=js&"
import style0 from "./offerList.vue?vue&type=style&index=0&id=bb4bc36c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4bc36c",
  null
  
)

export default component.exports